import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=5ab4cab2&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"
import style0 from "./statistics.vue?vue&type=style&index=0&id=5ab4cab2&lang=scss"
import style1 from "./statistics.vue?vue&type=style&index=1&id=5ab4cab2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab4cab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab4cab2')) {
      api.createRecord('5ab4cab2', component.options)
    } else {
      api.reload('5ab4cab2', component.options)
    }
    module.hot.accept("./statistics.vue?vue&type=template&id=5ab4cab2&scoped=true", function () {
      api.rerender('5ab4cab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-query/components-cool/statistics.vue"
export default component.exports